import { Component, OnInit, ViewChild, AfterContentInit, HostListener, AfterContentChecked } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { DataService } from '../data.service';
import { Trasllat } from '../lib/model/trasllat';
import { MatStepper } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-trasllat',
    styleUrls: ['trasllat.component.css'],
    templateUrl: './trasllat.component.html'
})
export class TrasllatComponent implements OnInit, AfterContentInit {

    @ViewChild('stepper') stepper: MatStepper;
    trasllat: Trasllat;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public dataService: DataService) {
        this.trasllat = dataService.trasllat;
        console.log(this.trasllat);
        if (this.trasllat.oferta == null) {
            this.router.navigate(['/login']);
        }
    }

    ngOnInit() {
    }

    ngAfterContentInit () {
        try {
            if (this.stepper !== null && (!this.trasllat.isnew) && this.trasllat.estat !== 64) {
                if (this.trasllat.oferta.pagaInscripcio === false ) {
                    this.stepper.selectedIndex = 4;
                } else {
                    this.stepper.selectedIndex = 5;
                }
            }
        } catch (ex) {
            console.log(ex.Message);
        }
    }

    @HostListener('window:beforeunload', ['$event'])
    public unloading($event) {
        console.log('Tries to unload'); // <---- this logs to the console.
        if (this.stepper.selectedIndex === 4) {
            // En el punt 4 (pagament) no ha d'avisar perquè ha de fer una redirecció, i seria estrany i contraproduent
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/trasllat/trasllat.component.ts